import React, { createContext, useContext, useState, useEffect } from 'react';
import axios from 'axios';

const AuthContext = createContext();

export function AuthProvider({ children }) {
  const [authToken, setAuthToken] = useState(() => localStorage.getItem('token') || '');
  const [tipoUsuario, setTipoUsuario] = useState(() => localStorage.getItem('tipoUsuario') || '');
  const [nombreUsuario, setnombreUsuario] = useState(() => localStorage.getItem('nombreUsuario') || '');
  const [isValidating, setIsValidating] = useState(true);

  // Validar token al iniciar - Si no hay token válido, limpiar y forzar login
  useEffect(() => {
    const validateToken = async () => {
      const token = localStorage.getItem('token');
      // const storedTipoUsuario = localStorage.getItem('tipoUsuario');
      // const storedNombreUsuario = localStorage.getItem('nombreUsuario');

      if (!token) {
        // No hay token, limpiar todo y forzar login
        localStorage.clear();
        setIsValidating(false);
        return;
      }

      // Configurar axios con el token antes de validar
      axios.defaults.headers.common['Authorization'] = `Bearer ${token}`;

      try {
        const apiUrl = process.env.REACT_APP_API_AUTH || '/api/auth';
        const response = await axios.get(`${apiUrl}/verify-token`, {
          headers: { Authorization: `Bearer ${token}` },
          timeout: 3000 // 3 segundos de timeout
        });

        if (response.data.valid) {
          // Token válido, actualizar todos los datos del usuario desde el servidor
          setAuthToken(token);
          setTipoUsuario(response.data.tipoUsuario);
          setnombreUsuario(response.data.nombreUsuario);

          // Actualizar localStorage con los datos más recientes
          localStorage.setItem('tipoUsuario', response.data.tipoUsuario);
          localStorage.setItem('nombreUsuario', response.data.nombreUsuario);
          if (response.data.nombreuser) localStorage.setItem('nombre', response.data.nombreuser);
          if (response.data.apellido) localStorage.setItem('apellido', response.data.apellido);
          if (response.data.sector) localStorage.setItem('sector', response.data.sector);
          if (response.data.id) localStorage.setItem('id', response.data.id);
        } else {
          // Token inválido, limpiar todo y forzar login
          localStorage.clear();
          setAuthToken('');
          setTipoUsuario('');
          setnombreUsuario('');
          delete axios.defaults.headers.common['Authorization'];
        }
      } catch (error) {
        console.error('Error validando token:', error.message);
        // Si hay error validando el token, limpiar sesión y forzar login
        console.log('Error validando token, limpiando sesión');
        localStorage.clear();
        setAuthToken('');
        setTipoUsuario('');
        setnombreUsuario('');
        delete axios.defaults.headers.common['Authorization'];
      } finally {
        setIsValidating(false);
      }
    };

    validateToken();
  }, []);

  useEffect(() => {
    // Este efecto se ejecuta cada vez que cambian las variables de estado authToken, tipoUsuario o usuarioAutenticado
    console.log('Autenticación correcta:', authToken, tipoUsuario, nombreUsuario);

    // Guardar en localStorage cuando cambien
    if (authToken) {
      localStorage.setItem('token', authToken);
    }
    if (tipoUsuario) {
      localStorage.setItem('tipoUsuario', tipoUsuario);
    }
    if (nombreUsuario) {
      localStorage.setItem('nombreUsuario', nombreUsuario);
    }
  }, [authToken, tipoUsuario, nombreUsuario]);

  function handleAuthenticationSuccess(data) {
    setAuthToken(data.token);
    setTipoUsuario(data.tipoUsuario);
    setnombreUsuario(data.nombreUsuario);
    if (data.nombreUsuario) {
      console.log('Nombre de usuario asignado:', data.nombreUsuario);
    } else {
      console.log('Nombre de usuario no proporcionado:', data.nombreUsuario);
    }
  }

  const iniciarSesion = (tipo, usuario) => {
    setTipoUsuario(tipo);
    setnombreUsuario(usuario);
  };

  const cerrarSesion = () => {
    localStorage.clear();
    setAuthToken('');
    setTipoUsuario('');
    setnombreUsuario('');
    // Limpiar el header de autorización de axios
    delete axios.defaults.headers.common['Authorization'];
  };

  // Mostrar loading mientras valida
  if (isValidating) {
    return (
      <div className="flex items-center justify-center min-h-screen bg-gray-900">
        <div className="text-white text-xl">Verificando sesión...</div>
      </div>
    );
  }

  return (
    <AuthContext.Provider
      value={{
        authToken,
        setAuthToken,
        tipoUsuario,
        iniciarSesion,
        setTipoUsuario,
        nombreUsuario,
        setnombreUsuario,
        handleAuthenticationSuccess,
        cerrarSesion,
        isValidating,
      }}
    >
      {children}
    </AuthContext.Provider>
  );
}

export function useAuth() {
  return useContext(AuthContext);
}
